import React, { useState } from "react";
import { FaEdit, FaTrash, FaPlusCircle, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AlertModal from "../../../Components/AlertModal/AlertModal";
import { API_BASE_URL } from "../../../Utils/constants";
import { deleteProperty } from "../../../services/propertyService";

const PropertiesListSection = ({ properties }) => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state


  const handleEdit = (id) => {
    console.log("Edit property with ID:", id);
    navigate(`/editproperty/${id}`);
  };

  const handleDelete = (id) => {
    setSelectedProperty(id);
    setIsModalOpen(true);
  };

   const confirmDelete = async () => {
    setLoading(true); // Start loading
    try {
      const response = await deleteProperty(selectedProperty);
      if (response.success) {
        alert("Property deleted successfully!");
        // Optionally, remove the deleted property from the properties list
        // You might need to refresh the list or update the state
      } else {
        alert("Failed to delete the property. Please try again.");
      }
    } catch (error) { 
      console.error("Error deleting property:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setLoading(false); // Stop loading
      setIsModalOpen(false);
      setSelectedProperty(null);
    }
  };

  const cancelDelete = () => {
    setIsModalOpen(false);
    setSelectedProperty(null);
  };

  const handleAddProperty = () => {
    navigate("/addproperty");
  };

  return (
    <div className="pt-10 px-8">
      <h2 className="text-xl font-bold mb-4">Properties</h2>
      {properties.length > 0 ? (
        <div className="grid grid-cols-1 gap-6">
          {properties.map((property) => (
            <div
              key={property._id}
              className="border border-gray-300 rounded-md p-4 shadow-sm flex items-center justify-between"
            >
              {/* Property Image */}
              <div className="flex items-center gap-4">
                <img
                  src={
                    `${API_BASE_URL}${property.images?.[0]?.fileUrl}` ||
                    "https://via.placeholder.com/150"
                  }
                  alt={property.title}
                  className="h-24 w-32 object-cover rounded-md border border-gray-200"
                  onError={(e) => {
                    e.target.src =
                      "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg";
                  }}
                />
                {/* Property Details */}
                <div>
                  <h3 className="text-lg font-semibold">{property.title}</h3>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Price:</span> ₹
                    {property.price.toLocaleString()}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Type:</span>{" "}
                    {property.propertyType}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Status:</span>{" "}
                    {property.status}
                  </p>

                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Location:</span>{" "}
                    {property.moreDetails?.Address || "N/A"}
                  </p>
                </div>
              </div>
              {/* Action Buttons */}
              <div className="flex items-center gap-4">
                <button
                  onClick={() => handleEdit(property._id)}
                  className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                >
                  <FaEdit />
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(property._id)}
                  className="flex items-center gap-2 px-3 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
                >
                  <FaTrash />
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4 py-10">
          <FaHome className="text-gray-400 text-6xl" />
          <p className="text-gray-600 text-lg">No properties available.</p>
          <button
            onClick={handleAddProperty}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
          >
            <FaPlusCircle />
            Add Property
          </button>
        </div>
      )}

      {/* Reusable Alert Modal */}
      <AlertModal
        isOpen={isModalOpen}
        message={
          loading
            ? "Deleting the property, please wait..."
            : "Are you sure you want to delete this property? This action cannot be undone."
        }        
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        isLoading={loading}
      />
    </div>
  );
};

export default PropertiesListSection;
